import React from 'react'
import ReloadTableContext from 'context/ReloadTableContext'
import Pallete from 'context/Palette'
import Router from './router/index'

function App() {
  return (
    <ReloadTableContext>
      <Pallete>
        <Router />
      </Pallete>
    </ReloadTableContext>
  )
}

export default App
